import { Link } from 'react-router-dom';
import { allComics } from '@/mocks/comics';

const picks = ['xia', 'shenye', 'jianzhou'];

export default function FeaturedSection() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            编辑<span className="text-secondary-600">推荐</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">高分经典与口碑佳作，编辑团队为你精选</p>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {picks.map((id) => {
            const comic = allComics.find((c) => c.id === id)!;
            return (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group flex gap-4 overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
              >
                <div className="relative h-40 w-28 shrink-0 overflow-hidden rounded-lg">
                  <img src={comic.cover} alt={`${comic.title}推荐封面`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                  <span className="absolute left-1.5 top-1.5 flex items-center gap-1 rounded-md bg-secondary-500 px-1.5 py-0.5 text-xs font-medium text-background-50">
                    <i className="ri-star-fill text-xs"></i>
                    {comic.rating.toFixed(1)}
                  </span>
                </div>
                <div className="flex flex-col">
                  <h4 className="font-medium text-foreground-950 group-hover:text-secondary-600 transition-colors">{comic.title}</h4>
                  <div className="mt-2 flex flex-wrap gap-1.5">
                    {comic.genres.slice(0, 3).map((g) => (
                      <span key={g} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                        {g}
                      </span>
                    ))}
                  </div>
                  <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-500">{comic.intro}</p>
                  <span className="mt-auto pt-2 text-sm font-medium text-secondary-600">
                    去看看 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}